export default __webpack_public_path__ + "static/media/questionnaire.5d7ac348.png";